/* home-redesign.js — shared behaviour for the split homepage sections
   (scroll-reveal + newsletter submit flash). Guarded so it's harmless to
   include from more than one of the split sections on the same page. */
(function () {
  if (window.__brdHomeRedesignInit) return;
  window.__brdHomeRedesignInit = true;

  function init() {
    // Scroll reveal
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.brd-reveal').forEach(function (el) { io.observe(el); });

    // Newsletter success flash
    var nf = document.getElementById('brd-newsletter-form');
    if (nf) {
      nf.addEventListener('submit', function () {
        var s = document.getElementById('brd-sent');
        if (s) { setTimeout(function () { s.style.opacity = '1'; }, 400); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
